<template>
  <div class="key-con">
    <div class="keyboardContainer" :class="[keyboardType]">
      <!-- <div class="key-setting">Keyboard Settings</div> -->
      <div :class="keyboardClass"></div>
      <!-- <div class="controlArrows">
    <div class="simple-keyboard-control"></div>
    <div class="simple-keyboard-arrows"></div>
  </div>

  <div class="numPad">
    <div class="simple-keyboard-numpad"></div>
    <div class="simple-keyboard-numpadEnd"></div>
  </div> -->
    </div>
    <div class="gesture" v-show="showGesture">
      <div
        class="left_gesture"
        :style="{
          backgroundImage: `url(${leftGestureDa})`,
        }"
      ></div>
      <div
        :class="{
          right_gesture: true,
          right_top_row: rightGestureKey.includes('right-top-row'),
          right_bottom_row: rightGestureKey.includes('right-bottom-row'),
        }"
        :style="{
          backgroundImage: `url(${rightGestureDa})`,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { gestureObj, rightGesture, leftGesture } from "./gestureRow.js";
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
// import "simple-keyboard/src/lib/components/Keyboard.css";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard-main",
      type: String,
    },
    input: {
      type: String,
    },
    nextInput: {
      type: String,
    },
    showGesture: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    gestureObj,
    leftGesture,
    rightGesture,
    rightGestureDa: null,
    leftGestureDa: null,
    leftGestureKey: "",
    rightGestureKey: "",
    keyboard: null,
    keyboardTypeClass: "keyboard-normal",
    showShiftTimmer: null,
    displayShiftOnly: {},
    displayDefault: {},
    capslockON: false,
    compare: () => {
      return true;
    },
  }),
  watch: {
    input(input) {
      console.log(input, "inputval==================");
      this.keyboard.setInput(input);
    },
    nextInput: {
      handler(val) {
        if (val === "") {
          this.leftGestureDa = require("./assets/images/gesture/left-resting-hand.webp");
          this.rightGestureDa = require("./assets/images/gesture/right-resting-hand.webp");
        } else {
          this.handlerGesture(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    keyboardType: {
      get: function () {
        return this.keyboardTypeClass;
      },
    },
  },
  mounted() {
    console.log(this.nextInput, "======-------==========nextInput");
    // if (this.nextInput !== "") {
    //   debugger
    //   this.handlerGesture(this.nextInput);
    // }
    this.rightGestureDa = require("./assets/images/gesture/right-resting-hand.webp");
    this.leftGestureDa = require("./assets/images/gesture/left-resting-hand.webp");
    console.log(this.gestureObj, "gestureObj");
    // debugger
    if (/macintosh|mac os x/i.test(navigator.userAgent)) {
      this.keyboardTypeClass = "keyboard-mac";
    } else {
      this.keyboardTypeClass = "keyboard-normal";
    }
    let charMap = [];
    for (let i = "a".charCodeAt(0); i <= "z".charCodeAt(0); i++) {
      charMap[String.fromCharCode(i)] = String.fromCharCode(
        "A".charCodeAt(0) + i - "a".charCodeAt(0)
      );
    }

    this.displayDefault = {
      ...charMap,
      "-": "<div class='key-group'><div class='up_'>_</div><div class='down'>-</div></div>",
      _: "<div class='key-group'><div class='up_'>_</div><div class='down'>-</div></div>",

      "=": "<div class='key-group'><div class='up'>+</div><div class='down'>=</div></div>",
      "+": "<div class='key-group'><div class='up'>+</div><div class='down'>=</div></div>",

      0: "<div class='key-group'><div class='up'>)</div><div class='down'>0</div></div>",
      ")": "<div class='key-group'><div class='up'>)</div><div class='down'>0</div></div>",

      9: "<div class='key-group'><div class='up'>(</div><div class='down'>9</div></div>",
      "(": "<div class='key-group'><div class='up'>(</div><div class='down'>9</div></div>",

      8: "<div class='key-group'><div class='up'>*</div><div class='down'>8</div></div>",
      "*": "<div class='key-group'><div class='up'>*</div><div class='down'>8</div></div>",

      7: "<div class='key-group'><div class='up'>&</div><div class='down'>7</div></div>",
      "&": "<div class='key-group'><div class='up'>&</div><div class='down'>7</div></div>",

      6: "<div class='key-group'><div class='up'>^</div><div class='down'>6</div></div>",
      "^": "<div class='key-group'><div class='up'>^</div><div class='down'>6</div></div>",

      5: "<div class='key-group'><div class='up'>%</div><div class='down'>5</div></div>",
      "%": "<div class='key-group'><div class='up'>%</div><div class='down'>5</div></div>",

      4: "<div class='key-group'><div class='up'>$</div><div class='down'>4</div></div>",
      $: "<div class='key-group'><div class='up'>$</div><div class='down'>4</div></div>",

      3: "<div class='key-group'><div class='up'>#</div><div class='down'>3</div></div>",
      "#": "<div class='key-group'><div class='up'>#</div><div class='down'>3</div></div>",

      2: "<div class='key-group'><div class='up'>@</div><div class='down'>2</div></div>",
      "@": "<div class='key-group'><div class='up'>@</div><div class='down'>2</div></div>",

      1: "<div class='key-group'><div class='up'>!</div><div class='down'>1</div></div>",
      "!": "<div class='key-group'><div class='up'>!</div><div class='down'>1</div></div>",

      "`": "<div class='key-group'><div class='up'>~</div><div class='down'>`</div></div>",
      "~": "<div class='key-group'><div class='up'>~</div><div class='down'>`</div></div>",

      "[": "<div class='key-group'><div class='up'>{</div><div class='down'>[</div></div>",
      "{": "<div class='key-group'><div class='up'>{</div><div class='down'>[</div></div>",

      "]": "<div class='key-group'><div class='up'>}</div><div class='down'>]</div></div>",
      "}": "<div class='key-group'><div class='up'>}</div><div class='down'>]</div></div>",

      "\\": "<div class='key-group'><div class='up'>|</div><div class='down'>\</div></div>",
      "|": "<div class='key-group'><div class='up'>|</div><div class='down'>\</div></div>",

      ";": "<div class='key-group'><div class='up'>:</div><div class='down'>;</div></div>",
      ":": "<div class='key-group'><div class='up'>:</div><div class='down'>;</div></div>",

      "'": "<div class='key-group'><div class='up'>\"</div><div class='down'>'</div></div>",
      '"': "<div class='key-group'><div class='up'>\"</div><div class='down'>'</div></div>",

      ",": "<div class='key-group'><div class='up'><</div><div class='down'>,</div></div>",
      "<": "<div class='key-group'><div class='up'><</div><div class='down'>,</div></div>",

      ".": "<div class='key-group'><div class='up'>></div><div class='down'>.</div></div>",
      ">": "<div class='key-group'><div class='up'>></div><div class='down'>.</div></div>",

      "/": "<div class='key-group'><div class='up'>?</div><div class='down'>/</div></div>",
      "?": "<div class='key-group'><div class='up'>?</div><div class='down'>/</div></div>",

      "{escape}": "esc ⎋",
      "{tab}": "tab ↹",
      "{backspace}": "delete ⌫",
      "{enter}": "enter ↵",
      "{capslock}": "caps lock⇪",
      "{shiftleft}": "shift ⇧",
      "{shiftright}": "shift ⇧",
      "{controlleft}": "ctrl",
      "{controlright}": "ctrl",
      // "{altleft}": "alt ⌥",
      "{altleft}": "alt",
      "{altright}": "alt",
      "{metaleft}": "cmd",
      "{metaright}": "cmd",
      "{fn}": "fn",

      // "{escape}": "<div class='key-esc'>esc ⎋</div>",
      // "{tab}": "<div class='key-tab'>tab ⇥</div>",
      // "{backspace}": "<div class='key-backspace'>delete ⌫</div>",
      // "{enter}": "<div class='key-enter'>enter ↵</div>",
      // "{capslock}": "<div class='key-capslock'>caps lock ⇪</div>",
      // "{shiftleft}": "<div class='key-shiftleft'>shift ⇧</div>",
      // "{shiftright}": "<div class='key-shiftright'>shift ⇧</div>",
      // "{controlleft}": "<div class='key-controlleft'>ctrl ⌃</div>",
      // "{controlright}": "<div class='key-controlright'>ctrl ⌃</div>",
      // "{altleft}": "<div class='key-altleft'>alt ⌥</div>",
      // "{altright}": "<div class='key-altright'>alt ⌥</div>",
      // "{metaleft}": "<div class='key-metaleft'>cmd ⌘</div>",
      // "{metaright}": "<div class='key-metaright'>cmd ⌘</div>"
    };
    this.displayShiftOnly = {
      "{escape}": "esc ⎋",
      "{tab}": "tab ↹",
      "{backspace}": "delete ⌫",
      "{enter}": "enter ↵",
      "{capslock}": "caps lock⇪",
      "{shiftleft}": "shift ⇧",
      "{shiftright}": "shift ⇧",
      "{controlleft}": "ctrl",
      "{controlright}": "ctrl",
      // "{altleft}": "alt ⌥",
      "{altleft}": "alt",
      "{altright}": "alt",
      "{metaleft}": "cmd",
      "{metaright}": "cmd",
      "{fn}": "fn",

      // "{escape}": "<div class='key-esc'>esc ⎋</div>",
      // "{tab}": "<div class='key-tab'>tab ⇥</div>",
      // "{backspace}": "<div class='key-backspace'>delete ⌫</div>",
      // "{enter}": "<div class='key-enter'>enter ↵</div>",
      // "{capslock}": "<div class='key-capslock'>caps lock ⇪</div>",
      // "{shiftleft}": "<div class='key-shiftleft'>shift ⇧</div>",
      // "{shiftright}": "<div class='key-shiftright'>shift ⇧</div>",
      // "{controlleft}": "<div class='key-controlleft'>ctrl ⌃</div>",
      // "{controlright}": "<div class='key-controlright'>ctrl ⌃</div>",
      // "{altleft}": "<div class='key-altleft'>alt ⌥</div>",
      // "{altright}": "<div class='key-altright'>alt ⌥</div>",
      // "{metaleft}": "<div class='key-metaleft'>cmd ⌘</div>",
      // "{metaright}": "<div class='key-metaright'>cmd ⌘</div>"
    };

    let commonKeyboardOptions = {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      onKeyReleased: this.onKeyReleased,
      onCompare: this.onCompare,
      theme: "simple-keyboard hg-theme-default hg-layout-default",
      physicalKeyboardHighlight: true,
      syncInstanceInputs: true,
      mergeDisplay: true,
      debug: true,
      useMouseEvents: false,
      usePointerEvents: false,
    };
    this.keyboard = new Keyboard(".simple-keyboard-main", {
      ...commonKeyboardOptions,
      layout: {
        default: [
          // "{escape} {f1} {f2} {f3} {f4} {f5} {f6} {f7} {f8} {f9} {f10} {f11} {f12}",
          "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
          "{tab} q w e r t y u i o p [ ] \\",
          "{capslock} a s d f g h j k l ; ' {enter}",
          "{shiftleft} z x c v b n m , . / {shiftright}",
          "{fn} {controlleft} {altleft} {metaleft} {space} {metaright} {altright} {arrowleft} {arrowup} {arrowdown} {arrowright}",
        ],
        shift: [
          "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
          "{tab} Q W E R T Y U I O P { } |",
          '{capslock} A S D F G H J K L : " {enter}',
          "{shiftleft} Z X C V B N M < > ? {shiftright}",
          "{fn} {controlleft} {altleft} {metaleft} {space} {metaright} {altright} {arrowleft} {arrowup} {arrowdown} {arrowright}",
        ],
        shiftonly: [
          // "{escape} {f1} {f2} {f3} {f4} {f5} {f6} {f7} {f8} {f9} {f10} {f11} {f12}",
          "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
          "{tab} Q W E R T Y U I O P { } |",
          '{capslock} A S D F G H J K L : " {enter}',
          "{shiftleft} Z X C V B N M < > ? {shiftright}",
          "{fn} {controlleft} {altleft} {metaleft} {space} {metaright} {altright} {arrowleft} {arrowup} {arrowdown} {arrowright}",
        ],
      },
      display: this.displayDefault,
    });

    // let keyboardControlPad = new Keyboard(".simple-keyboard-control", {
    //   ...commonKeyboardOptions,
    //   layout: {
    //     default: [
    //       "{prtscr} {scrolllock} {pause}",
    //       "{insert} {home} {pageup}",
    //       "{delete} {end} {pagedown}"
    //     ]
    //   }
    // });

    // let keyboardArrows = new Keyboard(".simple-keyboard-arrows", {
    //   ...commonKeyboardOptions,
    //   layout: {
    //     default: ["{arrowup}", "{arrowleft} {arrowdown} {arrowright}"]
    //   }
    // });

    // let keyboardNumPad = new Keyboard(".simple-keyboard-numpad", {
    //   ...commonKeyboardOptions,
    //   layout: {
    //     default: [
    //       "{numlock} {numpaddivide} {numpadmultiply}",
    //       "{numpad7} {numpad8} {numpad9}",
    //       "{numpad4} {numpad5} {numpad6}",
    //       "{numpad1} {numpad2} {numpad3}",
    //       "{numpad0} {numpaddecimal}"
    //     ]
    //   }
    // });

    // let keyboardNumPadEnd = new Keyboard(".simple-keyboard-numpadEnd", {
    //   ...commonKeyboardOptions,
    //   layout: {
    //     default: ["{numpadsubtract}", "{numpadadd}", "{numpadenter}"]
    //   }
    // });
  },
  methods: {
    handlerGesture(val) {
      if (this.rightGesture.includes(val.toUpperCase())) {
        this.leftGestureDa = require("./assets/images/gesture/left-resting-hand.webp");
        this.rightGestureDa = require(`./assets/images/gesture/${
          this.gestureObj[val.toUpperCase()]
        }`);
        this.leftGestureKey = "";
        this.rightGestureKey = this.gestureObj[val.toUpperCase()];
      } else if (this.leftGesture.includes(val.toUpperCase())) {
        this.rightGestureDa = require("./assets/images/gesture/right-resting-hand.webp");
        this.leftGestureDa = require(`./assets/images/gesture/${
          this.gestureObj[val.toUpperCase()]
        }`);
        this.rightGestureKey = "";
        this.leftGestureKey = this.gestureObj[val.toUpperCase()];
      }
    },
    onChange(input) {
      this.$emit("onChange", input);
    },
    onCompare(btn) {
      return this.compare(btn);
    },
    onKeyPress(button) {
      this.$emit("onKeyPress", button);
      console.log(button);
      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shiftright}" || button === "{shiftleft}") {
        this.handleShift("shift");
        this.showShiftTimmer = setTimeout(() => {
          this.handleShift("shiftonly");
          this.showShiftTimmer = null;
        }, 1500);
      } else if (button === "{capslock}") {
        this.capslockON = true;
        let currentLayout = this.keyboard.options.layoutName;
        let shiftToggle = currentLayout !== "default" ? "default" : "shift";
        this.handleShift(shiftToggle);
      }
    },
    onKeyReleased(button) {
      console.log("onKeyReleased", button);
      this.$emit("onKeyReleased", button);
      if (
        button === "{shiftright}" ||
        button === "{shiftleft}" ||
        button === "{capslock}"
      ) {
        if (this.showShiftTimmer) {
          clearTimeout(this.showShiftTimmer);
          this.showShiftTimmer = null;
        }
        if (button === "{capslock}") {
          this.capslockON = false;
        }
        if (this.capslockON) {
          this.handleShift("shift");
        } else {
          this.handleShift("default");
        }
      }
    },
    handleShift(layout) {
      // let currentLayout = this.keyboard.options.layoutName;
      // let shiftToggle = currentLayout === "default" ? "shift" : "default";
      console.log("currentLayout", layout);
      // debugger
      if (layout === "shiftonly") {
        this.keyboard.setOptions({
          layoutName: "shiftonly",
          display: this.displayShiftOnly,
        });
      } else {
        this.keyboard.setOptions({
          layoutName: layout,
          display: this.displayDefault,
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less">
.key-con {
  width: 800px;
  height: 400px;
  position: relative;
  margin: 0 auto;
}

.gesture {
  left: 50%;
  transform: translateX(-50%);
  top: -25px;
  height: 640px;
  position: absolute;
  width: 1200px;
  div[class$="_gesture"] {
    position: absolute;
    width: 630px;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .right_gesture {
    position: absolute;
    width: 630px;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    top: 10px;
    right: 86px;
  }
  .left_gesture {
    top: -24px;
    position: absolute;
    width: 630px;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    left: 0;
  }
  .right_top_row {
    top: 10px;
    right: 114px;
  }
  .right_bottom_row {
    // top: 16px;
    right: 74px;
  }
}
.key-setting {
  position: absolute;
}
input {
  width: 100%;
  height: 100px;
  padding: 20px;
  font-size: 20px;
  border: none;
  box-sizing: border-box;
}

.keyboardContainer {
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  position: absolute;
  display: flex;
  // background-color: rgba(0, 0, 0, 0.1);
  justify-content: center;
  /* width: 1024px; */
  margin: 0 auto;
  border-radius: 5px;
}

.simple-keyboard.hg-theme-default {
  display: inline-block;
}

.simple-keyboard-main.simple-keyboard {
  width: 800px;
  min-height: 342px;
  /* background: none; */
}

.simple-keyboard-main.simple-keyboard .hg-row:first-child {
  margin-bottom: 10px;
  // margin-top: 25px;
}
.simple-keyboard-main.simple-keyboard .hg-row {
  margin-bottom: 10px;
}

.simple-keyboard-arrows.simple-keyboard {
  align-self: flex-end;
  background: none;
}

.simple-keyboard .hg-button.selectedButton {
  background: rgba(5, 25, 70, 0.53);
  color: white;
}

.simple-keyboard .hg-button.emptySpace {
  pointer-events: none;
  background: none;
  border: none;
  box-shadow: none;
}

.simple-keyboard-arrows .hg-row {
  justify-content: center;
}

.simple-keyboard.hg-theme-default .hg-button {
  width: 50px;
  height: 50px;
  /* text-transform: uppercase; */
  font-family: museo-sans-rounded, sans-serif;
}
.simple-keyboard-arrows .hg-button {
  width: 50px;
  flex-grow: 0;
  justify-content: center;
  display: flex;
  align-items: center;
}

.controlArrows {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: column;
}

.simple-keyboard-control.simple-keyboard {
  background: none;
}

.simple-keyboard-control.simple-keyboard .hg-row:first-child {
  margin-bottom: 10px;
}

.simple-keyboard-control .hg-button {
  width: 50px;
  flex-grow: 0;
  justify-content: center;
  display: flex;
  align-items: center;
}

.numPad {
  display: flex;
  align-items: flex-end;
}

.simple-keyboard-numpad.simple-keyboard {
  background: none;
}

.simple-keyboard-numpad.simple-keyboard {
  width: 160px;
}

.simple-keyboard-numpad.simple-keyboard .hg-button {
  width: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.simple-keyboard-numpadEnd.simple-keyboard {
  width: 50px;
  background: none;
  margin: 0;
  padding: 5px 5px 5px 0;
}

.simple-keyboard-numpadEnd.simple-keyboard .hg-button {
  align-items: center;
  justify-content: center;
  display: flex;
}

.simple-keyboard-numpadEnd .hg-button.hg-standardBtn.hg-button-plus {
  height: 85px;
}

.simple-keyboard-numpadEnd.simple-keyboard .hg-button.hg-button-enter {
  height: 85px;
}

.simple-keyboard.hg-theme-default .hg-button.hg-selectedButton {
  background: rgba(5, 25, 70, 0.53);
  color: white;
}

.key-group .up_ {
  /* line-height: 50%; */
  margin-top: -10px;
  font-size: 14px;
}
.key-group .up {
  /* line-height: 50%; */
  line-height: 95%;
  font-size: 14px;
  margin-top: 3px;
}
.key-group .down {
  /* line-height: 50%; */
  line-height: 95%;
  margin-top: 6px;
}

.keyboard-mac .simple-keyboard.hg-theme-default {
  .hg-button-tab {
    width: 80px;
  }
  .hg-button-capslock {
    width: 95px;
  }
  .hg-button-shiftleft {
    width: 120px;
  }
  .hg-button-arrowdown {
    height: 25px;
    position: absolute;
    margin-left: 687px;
    margin-top: 26px;
    width: 50px;
  }
  .hg-button-arrowup {
    height: 25px;
  }
  .hg-button-backspace {
    width: 80px;
  }
  .hg-button-arrowup,
  .hg-button-arrowdown,
  .hg-button-arrowleft,
  .hg-button-arrowright {
    font-weight: 900;
  }
  .hg-button-metaright,
  .hg-button-metaleft,
  .hg-button-fn,
  .hg-button-controlleft,
  .hg-button-altleft,
  .hg-button-altright,
  .hg-button-controlleft,
  .hg-button-fn,
  .hg-button-backspace,
  .hg-button-enter,
  .hg-button-tab,
  .hg-button-shiftleft,
  .hg-button-shiftright,
  .hg-button-capslock {
    padding-top: 28px;
    font-size: 14px;
    /* text-align: start; */
    align-items: left;
    justify-content: left;
    padding-left: 6px;
  }
  .hg-button-enter {
    width: 90px;
    padding-left: 30px;
  }
  .hg-button-shiftright {
    width: 120px;
    padding-left: 70px;
  }
  .hg-button-metaright,
  .hg-button-metaleft {
    width: 70px;
  }
  .hg-button-fn,
  .hg-button-controlleft,
  .hg-button-altleft,
  .hg-button-altright {
    width: 48px;
  }
  .hg-button-space {
    width: 282px;
  }

  .hg-button-metaright {
    padding-left: 30px;
  }
  .hg-button-altright {
    padding-left: 20px;
  }
}
</style>
